import script from "./CardMitiRegistro.vue?vue&type=script&setup=true&lang=js"
export * from "./CardMitiRegistro.vue?vue&type=script&setup=true&lang=js"

import "./CardMitiRegistro.vue?vue&type=style&index=0&id=55b8c22e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55b8c22e"]])

export default __exports__